export const POP = "POP";
export const openPop = (data) => {
    return {
        type: POP,
        payload:data,
    }
}